import gql from 'graphql-tag';
import { Fragments } from '../fragments';

export const createBookmark = gql`
  mutation CreateBookmarkMutation($name: String!, $url: String!) {
    createBookmark(input: { name: $name, url: $url }) {
      ...BookmarkListItem
    }
  }

  ${Fragments.bookmark.bookmark}
`;

export const updateBookmark = gql`
  mutation UpdateBookmarkMutation($id: UUID!, $name: String!, $url: String!) {
    updateBookmark(input: { id: $id, name: $name, url: $url }) {
      ...BookmarkListItem
    }
  }

  ${Fragments.bookmark.bookmark}
`;

export const deleteBookmark = gql`
  mutation DeleteBookmarkMutation($id: UUID!) {
    deleteBookmark(id: $id)
  }
`;
